import React, { Component } from "react";

import { Card, CardContent, CardHeader } from "@mui/material";

import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";
import Environment from "../../utils/Environement";
import { shortenUUID } from "../../utils/formater";

interface PropsInterface {
  restaurant: PopinaRestaurant;
}

interface StateInterface {
  open: boolean;
}

class OptionsTableComponent extends Component {
  public props: PropsInterface;
  public state: StateInterface;

  constructor(props: PropsInterface) {
    super(props);
    this.state = {
      open: false
    };
    this.props = props;
  }

  render() {
    return (
      <div style={{ width: "80%", margin: "auto", padding: "0" }}>
        {this.props.restaurant
          .getAllOptionCategories()
          .map((sharedOption, index) => (
            <Card
              style={{
                margin: "30px 0",
                backgroundColor: "#F1F1F5"
              }}
              key={sharedOption.client_id}
            >
              <CardHeader
                title={
                  <>
                    {sharedOption.name}
                    <span
                      style={{
                        margin: 0,
                        fontWeight: 600,
                        marginLeft: "2px"
                      }}
                    >
                      ({shortenUUID(sharedOption.client_id)})
                    </span>
                  </>
                }
                disableTypography
                style={{
                  backgroundColor: "#474F5E",
                  color: "white",
                  fontSize: "20px"
                }}
              />
              <CardContent>
                {sharedOption.options.map((option, i) => (
                  <div
                    key={i}
                    style={{
                      border: Environment.isPopina
                        ? "1px solid #7ABF92"
                        : "1px solid #ffd400",
                      borderRadius: "3px",
                      backgroundColor: "white",
                      display: "flex",
                      margin: "5px",
                      padding: "12px 20px",
                      justifyContent: "space-around"
                    }}
                  >
                    <div
                      style={{
                        fontSize: "17px",
                        color: "#474F5E",
                        alignItems: "center",
                        paddingLeft: "20px",
                        visibility: "visible",
                        width: "30%"
                      }}
                    >
                      {option.name}
                      <span
                        style={{
                          color: "#33499ac2",
                          margin: 0,
                          fontWeight: "bold",
                          marginLeft: "2px"
                        }}
                      >
                        ({shortenUUID(option?.client_id)})
                      </span>
                    </div>
                    <p
                      style={{
                        color: "#33499ac2",
                        margin: 0,
                        fontWeight: "bold"
                      }}
                    >
                      {(option?.price || 0) / 100} EUR
                    </p>
                  </div>
                ))}
              </CardContent>
            </Card>
          ))}
      </div>
    );
  }
}

export default OptionsTableComponent;
